var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPowerOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#081132",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M6.431 3.818C4.651 5.001 3.3 6.727 2.58 8.74c-.72 2.013-.771 4.204-.145 6.249.626 2.044 1.896 3.83 3.62 5.094C7.777 21.347 9.862 22.02 12 22c2.136.019 4.222-.653 5.946-1.917 1.723-1.263 2.993-3.05 3.619-5.094.626-2.045.575-4.236-.145-6.25-.72-2.012-2.07-3.738-3.851-4.92M12 2v10"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOff);
export default __webpack_public_path__ + "static/media/power-off.f71323fa.svg";
export { ForwardRef as ReactComponent };